import { AlertTriangle } from "lucide-react";

export const SafetyBanner = () => (
  <div data-testid="safety-banner" className="relative bg-[#0A0A0A]">
    <div className="stripe-flash-top h-1.5 w-full" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <span className="flex items-center gap-3">
        <AlertTriangle size={28} className="word-red shrink-0" aria-hidden="true" />
        <span className="font-display font-bold uppercase tracking-normal text-2xl md:text-3xl leading-none">
          <span className="word-red">Slow</span> <span className="word-blue">Down</span> <span className="word-red">and</span> <span className="word-blue">Move</span> <span className="word-red">Over.</span>
        </span>
      </span>
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-400 sm:ml-auto sm:text-right leading-relaxed">
        It's the law in all 50 states —<br className="hidden sm:block" /> give roadside workers room to work
      </p>
    </div>
    <div className="stripe-flash-bottom h-1.5 w-full" aria-hidden="true" />
  </div>
);
